import CrudCustom from '../../../libs/custom/CrudCustom';

let TransaksiJurnalService = new CrudCustom('/transaksi-jurnals/belum-tersanding');
export default TransaksiJurnalService;
